class AdminUserDetails {
  constructor() {
    this.UserListDetailResp = null;
    this.UserRolesResp = null;
  }

  getUserDetailResp() {
    return this.UserListDetailResp;
  }

  setUserDetailResp(UserListDetailResp) {
    this.UserListDetailResp = UserListDetailResp;
  }

  getUserRolesResp() {
    return this.UserRolesResp;
  }

  setUserRolesResp(UserRolesResp) {
    this.UserRolesResp = UserRolesResp;
  }

  resetUserListDetails() {
    this.UserListDetailResp = null;
    this.UserRolesResp = null;
  }
}

export default new AdminUserDetails();
